<template>
  <div class="temp-container">
    <el-card class="box-card">
      <el-form label-width="80px">
        <el-form-item label="文本内容">
          <el-input v-model="text" type="textarea" :rows="4" placeholder="请输入内容" class="input-area"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="textSave">保存</el-button>
          <el-button type="success" @click="textGet">重置</el-button>
          <el-button type="danger" @click="textClean">清除</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <el-row class="upload-section">
        <el-upload
          class="upload-demo"
          action="noauth/temp/file/save"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeAvatarUpload"
          :before-remove="beforeRemove"
          :on-success="handleSuccess"
          :file-list="files">
          <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">上传文件不超过{{ fileMaxSize }}MB</div>
        </el-upload>
        <div class="file-buttons">
          <el-button size="small" type="success" @click="fileList">刷新</el-button>
          <el-button size="small" type="danger" @click="fileClean">清除文件</el-button>
        </div>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {textSave, textGet, textClean, fileGet, fileList, fileClean, fileRemove} from '../api/temp'
export default {
  name: 'temp',
  data () {
    return {
      // 表单参数
      fileMaxSize: 100,
      form: {},
      text: '',
      files: []
    }
  },
  methods: {
    textSave () {
      textSave(this.text).then(response => {
        if (response.data.toString() === 'true') {
          this.$message({
            message: '文本保存成功',
            type: 'success'
          })
        }
      })
    },
    textClean () {
      textClean().then(response => {
        if (response.data.toString() === 'true') {
          this.$message({
            message: '文本清除成功',
            type: 'success'
          })
          this.text = ''
        }
      })
    },
    textGet () {
      textGet().then(response => {
        this.text = response.data
      })
    },

    handleRemove (file, fileList) {
      fileRemove(file.name).then(response => {
        if (response.data.toString() === 'true') {
          this.$message({
            message: '文件删除成功',
            type: 'success'
          })
        }
      })
    },
    handlePreview (file) {
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = file.url
      link.download = file.name
      link.title = file.name
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < this.fileMaxSize

      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 500MB!')
      }
      return isLt2M
    },
    handleSuccess (response, file, fileList) {
      fileGet(file.name).then(response => {
        this.files.push(response.data)
      })
    },
    fileList () {
      fileList().then(response => {
        this.files = response.data
      })
    },
    fileClean () {
      fileClean().then(response => {
        if (response.data.toString() === 'true') {
          this.$message({
            message: '文件清除成功',
            type: 'success'
          })
          this.files = []
        }
      })
    }
  },
  mounted () {
    this.textGet()
    this.fileList()
  }
}
</script>

<style scoped>
.temp-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.box-card {
  max-width: 100%;
}
.input-area {
  width: 100%;
  max-width: 800px;
}
.upload-section {
  margin-top: 20px;
}
.file-buttons {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/temp.vue